export * from './save-to-compare';
export * from './compare';
export { default as addCompareCookieToStore } from './addCompareCookie';
export var RECEIVE_COMPARE_CARDS = 'RECEIVE_COMPARE_CARDS'; // Note: these 2 are duplicated with credit-cards-client

export var RECEIVE_CAT_BOOTSTRAP = 'RECEIVE_CAT_BOOTSTRAP';
export var RECEIVE_DETAILS_BOOTSTRAP = 'RECEIVE_DETAILS_BOOTSTRAP';